import Fancybox from '../../../src/js/shared/fancybox';

'use strict';

const $ = jQuery.noConflict();
$(function() {

	const ctaSection = {

		init: function() {
			this.initializePopup();
		},

		initializePopup: function() {
			if (!$('.js-cta-popup-trigger').length || !$('.js-cta-popup').length) {
				return;
			}

			Fancybox.initializefancyboxPopup('.js-cta-popup-trigger', '.js-cta-popup', 'popup-custom-class');

			$('.js-cta-popup-trigger').on('click', function() {
				$(this).attr('aria-expanded', 'true');
			});

			$(document).on('afterClose.fb', function() {
				$('.js-cta-popup-trigger').attr('aria-expanded', 'false');
			});
		},
	};

	ctaSection.init();
});
